<template>
<div class="group-work-guide-mask">
  <div class="guide" @click.stop="close"></div>
</div>
</template>
<script>
export default {
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="less" scoped>
.group-work-guide-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999;

  .guide {
    width: 5.52rem;
    height: 3.22rem;
    background: url('./img/guide.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    right: 0.2rem;
    top: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/courseCenter/public/groupWork/_guide.vue